// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.sdk.commons.api.dto.AbVersionInfo
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { AbSemanticVersionNumber } from "abweb/dto/generated/com/abinitio/sdk/commons/api/dto/AbSemanticVersionNumber";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class AbVersionInfo {
  static createAbVersionInfo(compatibility, semanticVersionNumber, versionNumber) {
    const retVal = new AbVersionInfo();
    retVal.initAbVersionInfo(compatibility, semanticVersionNumber, versionNumber);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createAbVersionInfo factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cascad.AbVersionInfo";
  }
  initFromJson(json, deserializeContext) {
    this.initAbVersionInfo(json.compatibility != null ? json.compatibility : null, TSOGUtils.decodeObject(json.semanticVersionNumber, AbSemanticVersionNumber, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "semanticVersionNumber")), json.versionNumber != null ? json.versionNumber : null);
  }
  initAbVersionInfo(compatibility, semanticVersionNumber, versionNumber) {
    this._compatibility = compatibility;
    this._semanticVersionNumber = semanticVersionNumber;
    this._versionNumber = versionNumber;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["compatibility"] = this._compatibility;
    retVal["semanticVersionNumber"] = TSOGUtils.toTSOGNativeObject(this._semanticVersionNumber, serializeContext);
    retVal["versionNumber"] = this._versionNumber;
    return retVal;
  }
  get compatibility() {
    return this._compatibility;
  }
  set compatibility(value) {
    this._compatibility = value;
  }
  get semanticVersionNumber() {
    return this._semanticVersionNumber;
  }
  set semanticVersionNumber(value) {
    this._semanticVersionNumber = value;
  }
  get versionNumber() {
    return this._versionNumber;
  }
  set versionNumber(value) {
    this._versionNumber = value;
  }
}
//# sourceMappingURL=AbVersionInfo.js.map
